import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IItemProps {
  $isMobile?: boolean;
  finishedMissions?: boolean;
}
export const Wrapper = styled.div`
  height: calc(100% - 10vh);
  max-width: 100%;
  width: 100%;
  position: fixed;
  bottom: 10vh;
  left: 0px;
  right: 0px;
  display: flex;
  flex-direction: column;
`

export const HomeWrapper = styled.div`
  width: 100%;
  padding-top: 120px;  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  overflow: auto;
`

export const MissionWrapper = styled.div`
  max-height: calc(100% - 8vh - 5px - 20px); // 8vh header, 5px margin top header, 20px margin bottom header 
  width: 100%;
  padding-top: 120px;
  padding-top: 120px;
  
  padding-top: 120px;  
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
`

export const MissionContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 85%;
  max-height: 50vh;
  padding: 1vh 1vw 0 calc(40px / 2);

  overflow: auto;
  scroll-behavior: smooth;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  & {
    scrollbar-width: thin;
    scrollbar-color: #fff rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 20px;
    border: 3px solid rgba(255,255,255, .19);
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    max-height: unset;
    padding: 0;
    overflow-x: initial;
    overflow-y: auto;
    display: none;
  }
`

// --------MOBILE----------//

export const Mobile = styled.section<IItemProps>`
  display: flex;
  flex-direction: column; 
 height: 100%;
  width: ${({ $isMobile }) => $isMobile ? '100%' : '60%'};
  align-items: center;
  ${({ $isMobile }) => !$isMobile && (`
    padding: 3vh 10px;
  `)}
`

export const MissionContainerMobileFinished = styled.div<IItemProps>`
  display: flex;
  width:  ${({ $isMobile }) => $isMobile ? '85%' : '100%'};
  max-width:  ${({ $isMobile }) => $isMobile ? '85%' : '100%'};
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: ${({ $isMobile }) => $isMobile ? '10px;' : '20px;'}
  margin-top: 15px;
  ${({ $isMobile }) => !$isMobile && (
    `
    background: #f8f6f7;
    border-radius: 10px;
    box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.08);
    border: 1px solid #e4e4e4;
    `
  )}
  
`
export const MissionContainerMobile = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
  justify-content: flex-start;
  margin-top: 15px;

  .content {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: unset;
    position: relative;

    &:before{
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      background-color: #000;
    }
  }

`

export const TitleWrapper = styled.div`
  text-align: center;
  h3 {
    font-weight: 400;
    font-size: ${customTheme.fontSizes.xs};
  }
`

export const Title = styled.h1`
font-size: ${customTheme.fontSizes.lg};
  text-align: center;
  color: ${({ color }) => color};
  width: 100%;
  
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;

  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  padding: 0 12px;
  margin-bottom: 6px;
`

export const Subtitle = styled.div<IItemProps>`
  font-size: ${({ $isMobile }) => $isMobile ? customTheme.fontSizes.sm : '1.8rem'};
  font-weight: 600;
  align-self: ${({ $isMobile }) => $isMobile ? 'flex-start' : 'center'};
  margin-left: ${({ $isMobile }) => $isMobile ? '0.8em' : '0'};
  margin-top: 1em;
  ${({ $isMobile }) => !$isMobile && ('margin-bottom: 20px')};
`

export const Subtext = styled.div`
  color: #1e1e1e;
  font-size: ${customTheme.fontSizes.xs};
  font-weight: 400;
  text-align: center;
  margin: 1em 0.5em;
`

export const YourMissionsText = styled.div`
  font-weight: normal;
  font-size: 4.5vw;
  line-height: 4.5vw;
  text-align: center;  
  color: ${({ color }) => color};
  padding: 0 5px;
  margin-bottom: 3px;
`

export const Content = styled.div<IItemProps>`
  ${({ $isMobile }) => $isMobile && ('align-self: center;')}
  width: 100%;
  ${({ $isMobile }) => $isMobile && ('margin: auto 0;')}
  ${({ $isMobile }) => $isMobile && ('padding-bottom: 75px;')}
`

export const AvailableMissionContent = styled.div<IItemProps>`
  ${({ $isMobile }) => $isMobile ? 'align-self: center;' : ''}
  width: 100%;
  ${({ $isMobile }) => $isMobile ? 'margin: auto 0;' : ''}
  ${({ $isMobile }) => $isMobile ? 'padding-bottom: 75px;' : ''}
  ${({ $isMobile }) => !$isMobile && (`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    `)}
`
export const Item = styled.div`
  display: flex !important;
  flex-wrap: wrap !important;
  align-self: center !important;
  justify-content: flex-start;
  align-items: center;
`

export const ContainerNoMission = styled.div`
  display: flex;
  align-self: center;
  flex: 1;
  justify-content: center;
  align-items: center;

  .mobile {
    display: flex;
    align-items: center;
  }

  img {
    height: unset;
    width: 50%;
    margin-bottom: auto;
  }

  h1 {
    margin-top: calc(100vh * 0.06);
  }
  
  h3 {
    color: #FFF;
    text-shadow: 2px 2px 32px #000000;
    text-align: center;

    margin: auto 0;
  }
`

export const ContainerNoMissionToAnswear = styled.div`
  display: flex;
  align-self: center;
  flex: 1;
  justify-content: center;
  align-items: center;

  .mobile {
    display: flex;
    align-items: center;
  }

  .emoticon {
    font-size: 96px;
    padding: 20px;
  }

  .description {
    margin: 0 calc(100vh * 0.02) calc(100vh * 0.03) calc(100vh * 0.02);
    text-align: center;
    color: ${({ color }) => color};
    font-weight: 400;
  }

`
export const FinishedMissionsDesktop = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 20px;
  padding: 20px;
`
